import React,{Component} from 'react';
import Select from 'react-select';

import HiddenInput from '../../../shared/components/HiddenInput';

import {FormText} from 'reactstrap';

import find from 'lodash/find';
import capitalize from 'lodash/capitalize'

import {typeOfContraints,formatStatus} from '../../../shared/utils';


function formatCampaignLabel(data){
  const campaign = data.campaign;
  return (
    <div>
      <span className='DropdownOptionSubtitle'>{formatStatus(campaign.status).toUpperCase()}</span><br />
      {campaign.name}
    </div>
  )
}


class CampaignCompletionInput extends Component {
  constructor(){
    super();

    this.state = {
      selectedCampaignOption:null,
    }
  }

  componentDidMount(){
    const { defaultValue, campaigns } = this.props;

    if(typeOfContraints(defaultValue) === 'completed'){
      const selectedCampaign = find(campaigns,(c) => c.id === defaultValue[0].requiredCampaignId);
      if(selectedCampaign){
        this.setState({
          selectedCampaignOption:{
            campaign:selectedCampaign,
            label:`${capitalize(selectedCampaign.status)} - ${selectedCampaign.name}`,
            value:selectedCampaign.id
          }
        });        
      }
    }
  }

  handleCampaignChange(e){
    this.setState({
      selectedCampaignOption:e
    });
    this.props.onCampaignChange(e.value);
    this.props.onChange();
  }

  render(){
    const { selectedCampaignOption } = this.state,
      { campaigns,warning } = this.props;

    return (
      <div>
        <HiddenInput 
          name='completedCampaignId' 
          value={selectedCampaignOption ? selectedCampaignOption.value : null} 
        />
        <Select 
          className='SubtitledReactSelectContainer'
          classNamePrefix='SubtitledReactSelect'
          value={selectedCampaignOption}
          isSearchable={false}
          options={campaigns.map((c) => ({campaign:c,label:`${capitalize(c.status)} - ${c.name}`,value:c.id}))} 
          onChange={(e) => this.handleCampaignChange(e)}
          formatOptionLabel={(arg) => formatCampaignLabel(arg)}
          placeholder='Select experience...'
        />
        {warning.length > 0 && (
          <FormText className='DangerFeedback'>{warning}</FormText>
        )}
      </div>
    )
  }
}

CampaignCompletionInput.defaultProps = {
  warning:''
};

export default CampaignCompletionInput;




// WEBPACK FOOTER //
// ./src/routes/GuidedCampaignAudience/components/CampaignCompletionInput.js